import { int64, Timestamp } from '@fullstory/proto/google/protobuf';
import { createSelector } from 'reselect';
import { AppState } from '../../types';
import { AppCacheStatus } from '@fullstory/redux-util/utils';
import { FilterState } from './types';

export const defaultCardFilters: FilterState = {
  page: 0,
  queryPage: 0,
  funnelStep: 0,
  funnelConverted: null,
  activeSegmentId: null,
  dimension: null,
  completeSessions: false,
  eventIndex: 0,
  returnEventIndex: 0,
  cohortIndex: 0,
  returnWindowIndex: 0,
};

const getCardFilters = (state: AppState) => state.sesionReplayFilters;

export const makeGetSessionReplayCardFilters = (storageId: string) =>
  createSelector(getCardFilters, filters => ({ ...defaultCardFilters, ...filters?.[storageId] }));

const getUsersAndSessions = (state: AppState) => state.sessionReplay.usersAndSessions;

export const makeGetIsLoading = (storageId: string) =>
  createSelector(
    getUsersAndSessions,
    usersAndSessions => usersAndSessions?.[storageId]?.status === AppCacheStatus.IsLoading ?? true,
  );

export const makeGetStatus = (storageId: string) =>
  createSelector(
    getUsersAndSessions,
    usersAndSesions => usersAndSesions?.[storageId]?.status ?? AppCacheStatus.IsLoading,
  );

export const makeGetComputedAt = (storageId: string) =>
  createSelector(
    getUsersAndSessions,
    usersAndSessions => usersAndSessions?.[storageId]?.data?.users?.computedAt ?? Timestamp.nil,
  );

export const makeGetUsersAndSessions = (storageId: string) =>
  createSelector(getUsersAndSessions, data => data[storageId]);

export const makeGetUsers = (storageId: string) =>
  createSelector(
    getUsersAndSessions,
    usersAndSesions =>
      usersAndSesions?.[storageId]?.data?.users?.generatedSearchie?.matchingUsersData?.users ?? [],
  );

export const makeGetUsersResponse = (storageId: string) =>
  createSelector(
    getUsersAndSessions,
    usersAndSesions => usersAndSesions?.[storageId]?.data?.users ?? null,
  );

export const makeGetNumMatchingUsers = (storageId: string) =>
  createSelector(getUsersAndSessions, usersAndSessions =>
    int64.toNumber(
      usersAndSessions?.[storageId]?.data?.users?.generatedSearchie?.matchingUsersData
        ?.matchingCounts?.numUsers,
    ),
  );

export const makeGetSessions = (storageId: string) =>
  createSelector(
    getUsersAndSessions,
    usersAndSesions => usersAndSesions?.[storageId]?.data?.sessions ?? {},
  );
